import {useCallback, useMemo, useState} from 'react';
import {useLocalParticipant, TrackReferenceOrPlaceholder} from '@livekit/components-react';
import {Track} from 'livekit-client';

export interface IUseLiveKitTracksReturn {
  isMuted: boolean;
  isCameraEnabled: boolean;
  isMicrophoneEnabled: boolean;
  micTrackRef: TrackReferenceOrPlaceholder;
  camTrackRef: TrackReferenceOrPlaceholder;
  unmute: () => Promise<void>;
  mute: () => Promise<void>;
}

export const useLiveKitTracks = (): IUseLiveKitTracksReturn => {
  const {cameraTrack, microphoneTrack, localParticipant, isMicrophoneEnabled, isCameraEnabled} =
    useLocalParticipant();

  const [isMuted, setIsMuted] = useState(false);

  const mute = useCallback(async () => {
    await localParticipant.setMicrophoneEnabled(false);
    setIsMuted(true);
  }, [localParticipant]);

  const unmute = useCallback(async () => {
    await localParticipant.setMicrophoneEnabled(true);
    setIsMuted(false);
  }, [localParticipant]);

  const micTrackRef: TrackReferenceOrPlaceholder = useMemo(() => {
    return {
      participant: localParticipant,
      source: Track.Source.Microphone,
      publication: microphoneTrack
    };
  }, [localParticipant, microphoneTrack]);

  const camTrackRef: TrackReferenceOrPlaceholder = useMemo(() => {
    return {
      participant: localParticipant,
      source: Track.Source.Camera,
      publication: cameraTrack
    };
  }, [cameraTrack, localParticipant]);

  return {
    mute,
    unmute,
    micTrackRef,
    camTrackRef,
    isMuted,
    isCameraEnabled,
    isMicrophoneEnabled
  };
};
